module.exports = __webpack_public_path__ + "static/media/qgen.a8e2aca4.png";